import TerrainSlope from './TerrainSlope';
export default TerrainSlope;
